import { createContext, useContext } from "react";
import { ILocationProps } from "../../../services/Location/types";
import { useLocationStream } from "../../../hooks/useLocationStream";

const LocationContext = createContext<ILocationProps[]>([]);

export const LocationProvider = ({ children }: { children: React.ReactNode }) => {
    const locations = useLocationStream("ws://localhost:5298/api/locations/stream");

    return (
        <LocationContext.Provider value={locations}>
            {children}
        </LocationContext.Provider>
    );
};

export const useLocations = () => useContext(LocationContext);
